var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInbox2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM15.874 14H19V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V14H8.12602C8.57006 15.7252 10.1362 17 12 17C13.8638 17 15.4299 15.7252 15.874 14ZM14 13C14 12.4477 14.4477 12 15 12H19V6C19 5.44772 18.5523 5 18 5H6C5.44772 5 5 5.44772 5 6V12H9C9.55228 12 10 12.4477 10 13C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox2Line);
export default __webpack_public_path__ + "static/media/inbox_2_line.2775fc719827e09d40ccc64b5f7bdab7.svg";
export { ForwardRef as ReactComponent };